import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

import { mostPopularDetailModalFallback } from '@/content/sessionCatalogBundles/sessionDetailModalFallbacks'

export const mostPopularBundleFallback: BookingSessionBundle = {
  internalName: 'Bundle: Most Popular',
  identifier: '',
  title: 'Most Popular',
  orderSummaryFriendlyName: '',
  tagline: '',
  features: '',
  highlightedFeatures: '',
  listingImage: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  listingImageMobile: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  badgeLabel: '',
  ctaLabel: '',
  priceLabel: '',
  showPrice: true,
  selectLabel: '',
  recommendedLabel: '',
  galleryLabel: '',
  detailsLabel: '',
  detailPageSlug: '',
  includedScenesLabel: '',
  compareLabel: '',
  cartSummaryFeatures: '',
  comparisonItems: [] as never,
  galleryImages: [] as never,
  upgradeModal: null,
  sessionsListingUpgradeModal: null,
  sceneSelectionPage: null,
  addOnsSelectionPage: null,
  detailPage: null,
  sessionDetailModal: mostPopularDetailModalFallback
} as unknown as BookingSessionBundle
